import { createRouter, createWebHistory } from 'vue-router'
import Anmo from '../components/Anmo.vue'
import UserAgreement from '../components/UserAgreement.vue'
import PrivacyPolicy from '../components/PrivacyPolicy.vue'
import AnchorAgreement from '../components/AnchorAgreement.vue'
import RechargeAgreement from '../components/RechargeAgreement.vue'
import AnchorRead from '../components/AnchorRead.vue'
import UserRead from '@/components/UserRead.vue'
import GoogleDelete from '@/components/GoogleDelete.vue'

const routes = [
  { 
    path: '/', 
    name: 'Home', 
    component: Anmo 
  },
  { 
    path: '/user-agreement', 
    name: 'UserAgreement', 
    component: UserAgreement 
  },
  { 
    path: '/privacy-policy', 
    name: 'PrivacyPolicy', 
    component: PrivacyPolicy 
  },
  { 
    path: '/anchor-agreement', 
    name: 'AnchorAgreement', 
    component: AnchorAgreement 
  },
  { 
    path: '/recharge-agreement', 
    name: 'RechargeAgreement', 
    component: RechargeAgreement 
  },
  {
    path: '/anchor-read',
    name: 'AnchorRead',
    component: AnchorRead
  },
  {
    path: '/user-read',
    name: 'UserRead',
    component: UserRead
  },
  {
    path: '/user-delete',
    name: 'UserDelete',
    component: GoogleDelete
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
